import React, { Component } from 'react';
import KheshtiRug from './rugTemplates/kheshtiRug';
import AfshanRug from './rugTemplates/afshanRug';
import LachakToranjRug from './rugTemplates/lachakToranjRug';
import ModernRug from "./rugTemplates/modernRug";

export default class SimilarRugsSidebar extends Component {

    render() {
        let rugs = [];
        if (this.props.rugs) {
            this.props.rugs.map((rug, i) => {
                let key = rug.id
                // Rug type is different when its coming from the API
                let rugType = rug.id ? rug.rug_type : rug.type
                switch (rugType) {
                    case "lachak-toranj":
                        rugs.push(
                            <li className="check" key={key} onClick={() => {this.props.clickHandler(rug, i)}}>
                                <span title={this.props.texts["rugSimilarityPercentage"]}> {rug.similarity}%</span>
                                <LachakToranjRug
                                    background={rug.background}
                                    border={rug.border}
                                    corner={rug.corner}
                                    toranj={rug.toranj}
                                    show={true}
                                />
                            </li>
                        );
                        break;
                    case "kheshti":
                        rugs.push(
                            <li className="check" key={key} onClick={() => {this.props.clickHandler(rug, i)}}>
                                <span title={this.props.texts["rugSimilarityPercentage"]}> {rug.similarity}%</span>
                                <KheshtiRug
                                    background={rug.background}
                                    tile={rug.tile}
                                    show={true}
                                />
                            </li>
                        );
                        break;
                    case "modern":
                        rugs.push(
                            <li className="check" key={key} onClick={() => {this.props.clickHandler(rug, i)}}>
                                <span title={this.props.texts["rugSimilarityPercentage"]}> {rug.similarity}%</span>
                                <ModernRug
                                    background={rug.background}
                                    pattern={rug.pattern}
                                    show={true}
                                />
                            </li>
                        );
                        break;
                    default:
                        rugs.push(
                            <li className="check" key={key} onClick={() => {this.props.clickHandler(rug, i)}}>
                                <span title={this.props.texts["rugSimilarityPercentage"]}> {rug.similarity}%</span>
                                <AfshanRug
                                    background={rug.background}
                                    border={rug.border}
                                    show={true}
                                />
                            </li>
                        );
                        break;
                    // case "lachak-toranj":
                    //     rugs.push(
                    //         <li className="check" key={key} onClick={() => {this.props.clickHandler(rug, i)}}>
                    //             <span title={this.props.texts["rugSimilarityPercentage"]}> {rug.similarity}%</span>
                    //             <LachakToranjRug
                    //                 background={rug.background}
                    //                 border={rug.border}
                    //                 corner={rug.corner}
                    //                 toranj={rug.toranj}
                    //                 show={true}
                    //             />
                    //             {/* <ImageRugs /> */}
                    //         </li>
                    //     )
                    //     break;
                    // case "kheshti":
                    //     rugs.push(
                    //         <li className="check" key={key} onClick={() => {this.props.clickHandler(rug, i)}}>
                    //             <span title={this.props.texts["rugSimilarityPercentage"]}> {rug.similarity}%</span>
                    //             <KheshtiRug
                    //                 background={rug.background}
                    //                 tile={rug.tile}
                    //                 show={true}
                    //             />
                    //         </li>
                    //     )
                    //     break;
                    // default:
                    //     rugs.push(
                    //         <li className="check active" key={key} onClick={() => {this.props.clickHandler(rug, i)}}>
                    //             <span title={this.props.texts["rugSimilarityPercentage"]}> {rug.similarity}%</span>
                    //             <AfshanRug
                    //                 background={rug.background}
                    //                 border={rug.border}
                    //                 show={true}
                    //             />
                    //         </li>
                    //     )
                    //     break;
                }
                return ""
            })
        }
        return (
            <div className="text-center similar-normal-display">
                <p> {this.props.texts["similarRugs"]} </p>
                <ul className="relative">
                    {rugs}
                </ul>
            </div>
        )
    }
}